export default {
    meta: {
        title: '更换责任人',
        url: '/standardstore/',
        urlName: '审批-通用流程',
    }
};
